import { useState, useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { useVersionCheck } from '../hooks/useVersionCheck'
import analytics from '../lib/analytics'

export const UpdateNotification = () => {
  const [showUpdateBanner, setShowUpdateBanner] = useState(false)
  const { handleAuthResponse, fetchVersion } = useVersionCheck({
    onVersionChanged: (newVersion: string, oldVersion: string) => {
      // Log version change to Sentry and GA4
      // Sentry: Log version update event
      Sentry.captureMessage('App version update detected', {
        level: 'info',
        tags: {
          event_type: 'version_update',
          old_version: oldVersion,
          new_version: newVersion,
          app_type: 'pwa',
        },
      })

      // GA4: Log version change event using analytics class
      analytics.trackEvent({
        action: 'app_updated',
        category: 'app_update',
        label: `${oldVersion} → ${newVersion}`,
      })

      // Update version tags in Sentry
      Sentry.setTag('app_version', newVersion)

      setShowUpdateBanner(true)
    }
  })

  // Expose the version check handler globally so authStore can call it
  useEffect(() => {
    ;(window as any).__versionCheck = { handleAuthResponse, fetchVersion }
  }, [handleAuthResponse, fetchVersion])

  const handleRefresh = () => {
    // Force reload to bypass service worker cache and load new version
    window.location.href = window.location.pathname + '?v=' + Date.now()
  }

  if (!showUpdateBanner) return null

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      backgroundColor: '#005bc0',
      color: '#ffffff',
      padding: 'calc(12px + env(safe-area-inset-top, 0px)) 16px 12px',
      zIndex: 1000,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    }}>
      <span style={{ fontSize: '14px', fontWeight: 500 }}>
        ✨ A new version is available
      </span>
      <button
        onClick={handleRefresh}
        style={{
          backgroundColor: '#ffffff',
          color: '#005bc0',
          border: 'none',
          padding: '6px 12px',
          borderRadius: '6px',
          fontSize: '13px',
          fontWeight: 600,
          cursor: 'pointer',
          flexShrink: 0,
        }}
      >
        Refresh
      </button>
    </div>
  )
}
